<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form @submit.prevent="onSubmit">
                <h1>Registro de usuario</h1>
                <p
                  class="text-muted"
                >Crea una cuenta de usuario para poder tener acceso al contenido en línea de la comunidad</p>

                <b-form-group label-for="nombre-usuario">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      id="nombre-usuario"
                      data-vv-as="Nombre"
                      name="nombre-usuario"
                      type="text"
                      class="form-control"
                      placeholder="Nombre"
                      autocomplete="nombre-usuario"
                      v-validate="'required|min:2'"
                      v-model="form.nombreUsuario"
                      :state="validateState('nombre-usuario')"
                      aria-describedby="input-1-live-feedback"
                      trim
                    />
                  </b-input-group>
                  <b-form-invalid-feedback :state="validateState('nombre-usuario')">
                    <span v-for="error in errors.collect('nombre-usuario')" :key="error">{{ error }}</span>
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label-for="email-usuario">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      id="email-usuario"
                      name="email-usuario"
                      type="email"
                      class="form-control"
                      placeholder="Correo electrónico"
                      data-vv-as="Correo electrónico"
                      autocomplete="email"
                      v-validate="'required|email'"
                      v-model="form.email"
                      :state="validateState('email-usuario')"
                    />
                  </b-input-group>
                  <b-form-invalid-feedback :state="validateState('email-usuario')">
                    <span v-for="error in errors.collect('email-usuario')" :key="error">{{ error }}</span>
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label-for="contraseña-usuario">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      id="contraseña-usuario"
                      name="contraseña-usuario"
                      type="password"
                      class="form-control"
                      placeholder="Contraseña"
                      data-vv-as="Contraseña"
                      autocomplete="new-password"
                      v-validate="'required'"
                      v-model="form.password"
                      :state="validateState('contraseña-usuario')"
                      ref="password"
                    />
                  </b-input-group>
                  <b-form-invalid-feedback :state="validateState('contraseña-usuario')">
                    <span
                      v-for="error in errors.collect('contraseña-usuario')"
                      :key="error"
                    >{{ error }}</span>
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label-for="confirmacion-usuario">
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      id="confirmacion-usuario"
                      name="confirmacion-usuario"
                      data-vv-as="Confirmar Contraseña"
                      v-validate="'required|confirmed:password'"
                      type="password"
                      class="form-control"
                      placeholder="Confirmar contraseña"
                      :state="validateState('confirmacion-usuario')"
                      v-model="form.confirm"
                    />
                  </b-input-group>
                  <b-form-invalid-feedback :state="validateState('confirmacion-usuario')">
                    <span
                      v-for="error in errors.collect('confirmacion-usuario')"
                      :key="error"
                    >{{ error }}</span>
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-button
                  type="submit"
                  variant="success"
                  block
                  :disabled="errors.any()"
                >Crear cuenta</b-button>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { UserService } from "@/services/user.service";
import { LicenciaService } from "@/services/licencia.service";
import { Promise } from "q";

export default {
  name: "registro_usuario",
  data() {
    return {
      form: {}
    };
  },
  methods: {
    onSubmit() {
      this.$validator
        .validateAll()
        .then(res => {
          if(res){
            UserService.SingIn(this.form).then(resp => {
              Promise.resolve({data: resp}).then(result => {
                console.log(result.data.data.success);
                if(result.data.data.success){
                  let userId = result.data.data.success._id;
                  // iniciar sesión automáticamente después de registrarse
                  UserService.login(result.data.data.success.email,this.form.password).then(resp => {
                    Promise.resolve({data:resp}).then(result => {
                      console.log(result.data);
                      if(result.data){
                        LicenciaService.getSearchMatchMacAddress().then(resp => {
                          Promise.resolve({data:resp}).then(result => {
                            if(result.data.success){
                              result.data.success.user = userId;
                              let data = {
                                query: { _id: result.data.success._id },
                                data: result.data.success
                              };

                              LicenciaService.updateLicencia(data).then(resp => {
                                Promise.resolve({data:resp}).then(result => {
                                  console.log("update:");
                                  console.log(result.data);
                                  if(result.data.success){
                                    this.$router.push('home');
                                  }
                                })
                              })
                            }
                          });
                          Promise.reject(new Error('fail')).then((error) => {
                            console.log(error);
                          });
                        })
                      }
                    });
                    Promise.reject(new Error('fail')).then((error) => {
                      console.log(error);
                    })
                  })
                }
              })
              Promise.reject(new Error('fail')).then((error) => {
                console.log(error);
              })
            })
          }
        })
        .catch(err => console.log(err));
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    }
  }
};
</script>